import {connect} from 'react-redux';
import ShopListItemComponent from "../components/ShopListItemComponent";
import Shop from "../../_data/models/Shop";
import {ShopsRoutes} from "../../routes";
import {fetchBoothsByShop} from "../../booth/middlewares";
import { initializeShopProfile} from "../middlewares";


const mapDispatchToProps = (dispatch, props) => {

    return {
        viewShop: (shop: Shop) => {
            dispatch(initializeShopProfile(shop.id));
            props.history.push(ShopsRoutes.view(shop.id));
        }
    };
};

const mapStateToProps = (state, props) => {

    return {
        shop: props.shop
    };
};

const ShopListItemContainer = connect(mapStateToProps, mapDispatchToProps)(ShopListItemComponent);
export default ShopListItemContainer;


// WEBPACK FOOTER //
// ./app/client/shop/container/ShopListItemContainer.ts